/**
 * Labels for audit entries. Core actions use ACTION_LABEL; feature modules record their own
 * action names (one label map per module, one line each below), labelled here so the Audit
 * page never shows a blank or a raw identifier where a word belongs. The hub's own changes
 * carry the machine id HUB_AUDIT_MACHINE ('hub').
 */
import { ACTION_LABEL, AIJOBS_AUDIT_LABEL, APPROVALS_AUDIT_LABEL, ASKS_AUDIT_LABEL, ATTACHMENTS_AUDIT_LABEL, AUDIT_OPS_AUDIT_LABEL, AUTH_AUDIT_LABEL, COMMENTS_AUDIT_LABEL, CONTROL_AUDIT_LABEL, DISCIPLINE_ACTION_LABEL, FLEET_AUDIT_LABEL, FLOWS_AUDIT_LABEL, HUB_AUDIT_MACHINE, MISSIONS_ACTION_LABEL, PAIR_AUDIT_LABEL, PROJECT_PROTOCOL_AUDIT_LABEL, SCHEDULER_ACTION_LABEL, TEAMS_AUDIT_LABEL, TERM_AUDIT_LABEL, TRUST_AUDIT_LABEL, WATCH_AUDIT_LABEL } from '@orgus/protocol';
import type { ActionKind, Machine } from '@orgus/protocol';

const MODULE_LABELS: Record<string, string>[] = [
  AUTH_AUDIT_LABEL,
  TRUST_AUDIT_LABEL,
  FLEET_AUDIT_LABEL,
  MISSIONS_ACTION_LABEL,
  SCHEDULER_ACTION_LABEL,
  TERM_AUDIT_LABEL,
  APPROVALS_AUDIT_LABEL,
  ASKS_AUDIT_LABEL,
  DISCIPLINE_ACTION_LABEL,
  AUDIT_OPS_AUDIT_LABEL,
  TEAMS_AUDIT_LABEL,
  CONTROL_AUDIT_LABEL,
  ATTACHMENTS_AUDIT_LABEL,
  COMMENTS_AUDIT_LABEL,
  AIJOBS_AUDIT_LABEL,
  FLOWS_AUDIT_LABEL,
  PROJECT_PROTOCOL_AUDIT_LABEL,
  PAIR_AUDIT_LABEL,
  WATCH_AUDIT_LABEL,
];

/** 'mission.start' gives 'Start mission'; an unknown 'foo.bar_baz' gives 'Foo bar baz'. */
export function auditActionLabel(action: string): string {
  const core = ACTION_LABEL[action as ActionKind];
  if (core) return core;
  for (const m of MODULE_LABELS) if (m[action]) return m[action]!;
  const words = action.replace(/[._-]+/g, ' ').trim();
  return words ? words.charAt(0).toUpperCase() + words.slice(1) : 'Action';
}

/** The machine an entry ran on: its name, 'Hub' for the hub's own changes, else `removed`. */
export function auditMachineName(machineId: string, machines: Record<string, Machine | undefined>, removed = 'Removed'): string {
  if (machineId === HUB_AUDIT_MACHINE) return 'Hub';
  return machines[machineId]?.name ?? removed;
}
